<template>
  <div class="addressInfoDialog">
    <div
      class="addressInfoDialog-content"
      v-if="!showSuccessDialog"
    >
      <img
        src="@/assets/offer/address-header.svg"
        alt=""
        class="addressInfoDialog-header-img"
      >
      <div class="addressInfoDialog-body">
        <div class="addressInfoDialog-main">
          <div class="header-text">
            Add shipping address to help us build your delivery posting
          </div>
        </div>
        <div
          v-if="isValidAddress"
          class="invalid-address"
        >
          <img
            src="@/assets/status/error-red.svg"
            width="12px"
            height="12px"
            alt=""
          >
          The logistics cannot be delivered at the moment. Please contact customer service for more information!
        </div>
        <div class="intelligent">
          Intelligent Recognition
        </div>
        <div
          class="identify-address"
          :class="{ focus: intelligentFocus }"
        >
          <img
            v-if="identifyAddress"
            @click="identifyAddress = ''"
            class="clear-btn"
            src="@/assets/images/close-icon.svg"
            alt=""
          >
          <textarea
            v-model="identifyAddress"
            @focus="intelligentFocus = true"
            @blur="intelligentFocus = false"
            @input="adjustHeight"
            placeholder="{Identify clipboard address} Intelligent splitting of names, phone numbers, and addresses."
          />
          <div
            v-if="!identifyAddress"
            @click="handlePasteAddress"
            class="identify-address-btn"
          >
            Identify Clipboard
          </div>
          <div
            v-else
            class="identify-address-btn"
            :class="{ identifying: identifying }"
            @click="handleIdentify"
          >
            <div
              v-if="identifying"
              class="loading"
            />
            {{ identifying ? 'Identifying your address' : 'Identify' }}
          </div>
        </div>
        <div class="form form-first">
          <div class="form-item">
            <label
              for="name"
              class="form-item-title"
            >Name*</label>
            <input
              type="text"
              class="form-name-input"
              v-model="formParams.name"
              @input="(e) => handleInput(e, 'name')"
            >
            <div
              class="address-error"
              v-if="verifyNameError"
            >
              <img
                src="@/assets/error.svg"
                alt=""
              > {{ verifyNameError }}
            </div>
          </div>
          <div class="form-item">
            <label
              for="name"
              class="form-item-title"
            >Phone Number</label>
            <div class="form-item-phone">
              <div class="country-item">
                <img
                  :src="formParams.areaCodeImg"
                  alt=""
                  style="width: 20px; height: 15px;"
                  class="country-img"
                >
                <input
                  v-model="formParams.phoneCode"
                  @focus="openAreaDropdown"
                  @blur="closeAreaDropdown"
                  @input="filterAreaCodeOptions"
                  :placeholder="formParams.placeholderSearchText"
                  class="form-country-input areaCode-select"
                >
                <img
                  src="@/assets/offer/address-down.svg"
                  alt=""
                  class="phone-down"
                >
                <Transition name="dropdown-fade">
                  <div
                    v-if="isAreaCodeDropdownOpen"
                    class="dropdown areaCode-dropdown"
                  >
                    <div
                      v-for="option in filteredCountryList"
                      :key="option.countryName"
                      @click="selectAreaCodeOption(option)"
                      class="dropdown-item"
                    >
                      <img
                        :src="option?.countryUrl"
                        alt=""
                        class="dropdown-item-img"
                      >
                      {{ option.countryName }}
                      {{ (option.phoneCode) }}
                    </div>
                  </div>
                </Transition>
              </div>
              <input
                type="text"
                class="form-name-input areaCode-input"
                v-model="formParams.phoneValue"
              >
            </div>
          </div>
        </div>
        <div class="form form-country">
          <div class="form-item">
            <label
              for="name"
              class="form-item-title"
            >Country*</label>
            <div class="country-item">
              <img
                :src="formParams.searchImg"
                alt=""
                style="width: 20px; height: 15px;"
                class="country-img"
              >
              <input
                v-model="formParams.searchCountryText"
                @focus="openDropdown"
                @blur="closeDropdown"
                @input="filterOptions"
                :placeholder="formParams.placeholderSearchText"
                class="form-country-input"
              >
            </div>
            <Transition name="dropdown-fade">
              <div
                v-if="isDropdownOpen"
                class="dropdown"
              >
                <div
                  v-for="option in filteredCountryList"
                  :key="option.countryName"
                  @click="selectOption(option)"
                  class="dropdown-item"
                >
                  <img
                    :src="option?.countryUrl"
                    alt=""
                    class="dropdown-item-img"
                  >
                  {{ option.countryName }}
                </div>
              </div>
            </Transition>
          </div>
          <div
            v-if="formParams.searchCountryText === 'Brazil'"
            class="form-item"
          >
            <label
              for="name"
              class="form-item-title"
              style="height: 18px;"
            />
            <div class="special-support-wrapper">
              <div class="flag">
                CPF
              </div>
              <input
                type="text"
                class="form-name-input"
                style="flex: 1;"
                v-model="formParams.cpfNumber"
                @input="(e) => handleInput(e, 'cpfNumber')"
                placeholder="CPF Number*"
              >
            </div>
            <div
              class="address-error"
              v-if="verifyCpfNumberError"
            >
              <img
                src="@/assets/error.svg"
                alt=""
              > {{ verifyCpfNumberError }}
            </div>
          </div>
          <div
            v-if="formParams.searchCountryText === 'Chile'"
            class="form-item"
          >
            <label
              for="name"
              class="form-item-title"
              style="height: 18px;"
            />
            <div class="special-support-wrapper">
              <div class="flag">
                RUT
              </div>
              <input
                type="text"
                class="form-name-input"
                style="flex: 1;"
                v-model="formParams.rutNumber"
                @input="(e) => handleInput(e, 'rutNumber')"
                placeholder="RUT Number*"
              >
            </div>
            <div
              class="address-error"
              v-if="verifyCpfNumberError"
            >
              <img
                src="@/assets/error.svg"
                alt=""
              > {{ verifyCpfNumberError }}
            </div>
          </div>
        </div>
        <div class="form">
          <div class="form-item">
            <label
              for="name"
              class="form-item-title"
            >Street Address*</label>
            <input
              type="text"
              class="form-name-input"
              v-model="formParams.streetAddress"
              @input="(e) => handleInput(e, 'streetAddress')"
            >
            <div
              class="address-error"
              v-if="verifyStreetAddressError"
            >
              <img
                src="@/assets/error.svg"
                alt=""
              > {{ verifyStreetAddressError }}
            </div>
          </div>
          <div class="form-item">
            <label
              for="name"
              class="form-item-title"
            >Apt, suite, etc. (optional)</label>
            <input
              type="text"
              class="form-name-input"
              v-model="formParams.aptEtc"
              @input="(e) => handleInput(e, 'aptEtc')"
            >
            <!-- <div class="address-error" v-if="verifyAptEtcError">
              <img src="@/assets/error.svg" alt="" /> {{ verifyAptEtcError }}
            </div> -->
          </div>
          <div class="form-item">
            <label
              for="name"
              class="form-item-title"
            >State / Province*</label>
            <input
              type="text"
              class="form-name-input"
              v-model="formParams.province"
              @input="(e) => handleInput(e, 'province')"
            >
            <div
              class="address-error"
              v-if="verifyAptProvinceError"
            >
              <img
                src="@/assets/error.svg"
                alt=""
              > {{ verifyAptProvinceError }}
            </div>
          </div>
          <div class="form-item">
            <label
              for="name"
              class="form-item-title"
            >City / Suburb*</label>
            <input
              type="text"
              class="form-name-input"
              v-model="formParams.city"
              @input="(e) => handleInput(e, 'city')"
            >
            <div
              class="address-error"
              v-if="verifyAptCityError"
            >
              <img
                src="@/assets/error.svg"
                alt=""
              > {{ verifyAptCityError }}
            </div>
          </div>
          <div class="form-item form-item-bottom">
            <label
              for="name"
              class="form-item-title"
            >Post Code*</label>
            <input
              type="text"
              class="form-name-input"
              v-model="formParams.postCode"
              @input="(e) => handleInput(e, 'postCode')"
            >
            <div
              class="address-error"
              v-if="verifyAptPostCodeError"
            >
              <img
                src="@/assets/error.svg"
                alt=""
              > {{ verifyAptPostCodeError }}
            </div>
          </div>
          <div class="form-item form-item-bottom">
            <label
              for="name"
              class="form-item-title"
            >Email</label>
            <input
              type="text"
              class="form-name-input"
              v-model="formParams.email"
              @input="(e) => handleInput(e, 'email')"
            >
            />
            <div
              class="address-error"
              v-if="verifyEmailError"
            >
              <img
                src="@/assets/error.svg"
                alt=""
              > {{ verifyEmailError }}
            </div>
          </div>
        </div>
      </div>
      <div class="addressInfoDialog-bottom">
        <div
          class="addressInfoDialog-cancel"
          @click="handleCancel"
        >
          Cancel
        </div>
        <div
          class="addressInfoDialog-save"
          @click="saveAddress"
        >
          Save
        </div>
      </div>
    </div>
    <div
      class="addressInfoDialog-success"
      v-if="showSuccessDialog"
    >
      <div class="success-content">
        <img
          src="@/assets/offer/address-success.png"
          alt=""
          class="success-header-img"
        >
        <div class="success-title">
          Sourcing Request Successful
        </div>
        <div class="success-desc">
          We will notify you of the procurement results via email, so please pay attention to check it at that time.
        </div>
        <div
          class="success-btn"
          @click="handleClose"
        >
          Confirm
        </div>
      </div>
      <div
        class="addressInfoDialog-close"
        @mouseenter="mouseenter"
        @mouseleave="mouseleave"
        @click="handleClose"
      >
        <img
          src="@/assets/offer/address-close.svg"
          alt=""
          v-if="!showHoveredClose"
        >
        <img
          src="@/assets/offer/address-hover-close.svg"
          alt=""
          v-if="showHoveredClose"
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { fetchData } from '@/utils/fetch'
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import { usePlugin } from '@/hooks/usePlugin'
import { useUserStore } from '@/pinia/user'

const store = useStore()
const user = useUserStore()

const props = defineProps({
  currentCountry: Object,
  handleClose: Function,
  addressType: Number
})

const currentCountry = props.currentCountry
const handleClose = props.handleClose
const countryList = computed(() => store.state.countryInfo)

const userInfo = computed(() => user.userInfo)
const showHoveredClose = ref(false)

const crrencyDataUpdated = computed(() => store.state.currencyData)

const getCountryList = computed(() => store.state.countryInfo)

const filteredCountryList = ref(countryList.value)

const isDropdownOpen = ref(false)
const isAreaCodeDropdownOpen = ref(false)
const showSuccessDialog = ref(false)
const isValidAddress = ref(false)

const emit = defineEmits(['saveAddress'])

const address = localStorage.getItem('addressForm')
  ? JSON.parse(localStorage.getItem('addressForm'))
  : {
      name: '',
      searchImg: currentCountry?.countryUrl,
      phoneCode: currentCountry?.phoneCode,
      searchCountryText: '',
      placeholderSearchText: currentCountry?.countryName,
      streetAddress: '',
      aptEtc: '',
      province: '',
      city: '',
      postCode: '',
      email: userInfo.value?.email,
      areaCodeImg: currentCountry?.countryUrl,
      placeholderAreaCodeText: `${currentCountry?.countryName} (${currentCountry.phoneCode})`,
      phoneValue: '',
      countryCode: currentCountry?.countryCode,
      cpfNumber: ''
    }

const formParams = reactive(address)

const handleCancel = () => {
  buriedPointUtil({ eventId: 'PAE202', others: { addressType: props.addressType } })
  handleClose()
}

const touched = reactive({
  name: false,
  streetAddress: false,
  aptEtc: false,
  province: false,
  city: false,
  postCode: false,
  email: false,
  cpfNumber: ''
})

const verifyNameError = computed(() => {
  if (!formParams.name && touched.name) return 'The Name is required.'
  if (formParams.name.length > 100) return 'Cannot exceed 100 characters.'
  return ''
})

const verifyCpfNumberError = computed(() => {
  if (!formParams.cpfNumber && touched.cpfNumber) return 'The CPF Number is required.'
  if (formParams.cpfNumber?.length > 32) return 'Cannot exceed 200 characters.'
})

const verifyRutNumberError = computed(() => {
  if (!formParams.rutNumber && touched.rutNumber) return 'The RUT Number is required.'
  if (formParams?.rutNumber?.length > 32) return 'Cannot exceed 32 characters.'
  return ''
})

const verifyStreetAddressError = computed(() => {
  if (!formParams.streetAddress && touched.streetAddress) return 'The Street Address is required.'
  if (formParams.streetAddress.length > 200) return 'Cannot exceed 200 characters.'
  return ''
})

// const verifyAptEtcError = computed(() => {
//   if (!formParams.aptEtc && touched.aptEtc) return 'The Apt, suite, etc. (optional) is required.';
//   if (formParams.aptEtc.length > 200) return 'Cannot exceed 200 characters.';
//   return '';
// });

const verifyAptProvinceError = computed(() => {
  if (!formParams.province && touched.province) return 'The State / Province is required.'
  return ''
})

const verifyAptCityError = computed(() => {
  if (!formParams.city && touched.city) return 'The City / Suburb is required.'
  return ''
})

const verifyAptPostCodeError = computed(() => {
  if (!formParams.postCode && touched.postCode) return 'The Post Code is required.'
  if (formParams.postCode.length > 20) return 'Cannot exceed 20 characters.'
  return ''
})

const verifyEmailError = computed(() => {
  if (formParams.email?.length > 100) return 'Cannot exceed 100 characters.'
  return ''
})

const handleInput = (e, file) => {
  formParams[file] = e.target.value
  touched[file] = true
}

const saveAddress = async () => {
  buriedPointUtil({ eventId: 'PAE201', others: { addressType: props.addressType } })
  if (!!verifyNameError.value || !formParams.name) {
    touched.name = true
    return
  }
  let extension
  if (formParams.searchCountryText === 'Brazil') {
    if (!!verifyCpfNumberError.value || !formParams.cpfNumber) {
      touched.cpfNumber = true
      return
    }
    extension = formParams.cpfNumber
  }

  if (formParams.searchCountryText === 'Chile') {
    if (!!verifyRutNumberError.value || !formParams.rutNumber) {
      touched.rutNumber = true
      return
    }
    extension = formParams.rutNumber
  }

  if (!!verifyStreetAddressError.value || !formParams.streetAddress) {
    touched.streetAddress = true
    return
  }
  // if (!!verifyAptEtcError.value || !formParams.aptEtc) {
  //   touched.aptEtc = true;
  //   return;
  // }
  if (!!verifyAptProvinceError.value || !formParams.province) {
    touched.province = true
    return
  }
  if (!!verifyAptCityError.value || !formParams.city) {
    touched.city = true
    return
  }
  if (!!verifyAptPostCodeError.value || !formParams.postCode) {
    touched.postCode = true
    return
  }

  if (verifyEmailError.value) {
    touched.postCode = true
    return
  }

  const { code, data, msg } = await fetchData('/appb/b2b/Logistics/checkSupportDeliveryByAddress', {
    method: 'POST',
    body: JSON.stringify({ ...address, extension, streetAddr: address?.streetAddress, zip: address?.postCode, phone: address?.phoneValue, country: address?.searchCountryText, extAddr: address?.aptEtc })
  })

  if (code !== 200) {
    isValidAddress.value = true
    buriedPointUtil({ eventId: 'PAE401', others: { addressType: props.addressType } })
    $toast(msg, { type: 'error' })
    return
  }

  buriedPointUtil({ eventId: 'PAE201', others: { addressType: props.addressType } })
  gaAnalytics('p_address_save_success', 'p_address_save_success')
  localStorage.setItem('addressForm', JSON.stringify({ ...address, extension, streetAddr: address?.streetAddress, zip: address?.postCode, phone: address?.phoneValue, country: address?.searchCountryText, extAddr: address?.aptEtc }))
  emit('saveAddress')
}

const openDropdown = (e) => {
  isDropdownOpen.value = true
}

const closeDropdown = () => {
  isDropdownOpen.value = false
}

const openAreaDropdown = () => {
  isAreaCodeDropdownOpen.value = true
}

const closeAreaDropdown = () => {
  isAreaCodeDropdownOpen.value = false
}

const selectOption = (option) => {
  formParams.searchCountryText = option.countryName
  formParams.placeholderSearchText = option.countryName
  formParams.searchImg = option.countryUrl,
  formParams.countryCode = option.countryCode
  closeDropdown()
}

const filterOptions = (e) => {
  filteredCountryList.value = countryList.value.filter(v =>
    v.countryName.toLowerCase().includes(e.target.value.toLowerCase())
  )
}

const selectAreaCodeOption = (option) => {
  formParams.placeholderAreaCodeText = `${option.countryName} (${option.phoneCode})`
  formParams.areaCodeImg = option.countryUrl
  formParams.phoneCode = option.phoneCode
  closeDropdown()
}

const filterAreaCodeOptions = (e) => {
  filteredCountryList.value = countryList.value.filter(v =>
    v.countryName.toLowerCase().includes(e.target.value.toLowerCase())
  )
}

const mouseenter = () => {
  showHoveredClose.value = true
}

const mouseleave = () => {
  showHoveredClose.value = false
}

// 识别地址相关逻辑
const { $toast } = usePlugin()

const identifyAddress = ref('')
const identifying = ref(false)
const intelligentFocus = ref(false)

const adjustHeight = (e) => {
  e.target.style.height = 'auto'
  const height = e.target.scrollHeight
  e.target.style.height = height + 'px'
}

const handlePasteAddress = async () => {
  const text = await navigator.clipboard.readText()
  if (!text.trim()) {
    $toast('There is no available address. Please copy it and try again.')
    return
  }
  identifyAddress.value = text
}

const handleIdentify = async () => {
  buriedPointUtil({ eventId: 'PAE203', others: { addressType: props.addressType } })
  identifying.value = true

  const params = {
    address: identifyAddress.value
  }

  try {
    const { code, data, msg } = await fetchData('/appb/alibaba-inter/addressResolution', {
      method: 'post',
      body: JSON.stringify(params)
    })
    if (code === 200) {
      formParams.name = data.name
      formParams.searchAreaCodeText = data.phoneCode
      formParams.phoneValue = data.phone
      formParams.streetAddress = data.streetAddr
      formParams.aptEtc = data.extAddr
      formParams.province = data.province
      formParams.city = data.city
      formParams.postCode = data.zip
      formParams.email = data.email
      identifying.value = false

      const item = getCountryList.value.find(item => item.countryName === data.country)
      if (item) {
        formParams.searchCountryText = item.countryName
        formParams.searchImg = item.countryUrl
        formParams.countryCode = item.countryCode
      }
    }
    identifying.value = false
    $toast('Identify successfully')
  } catch (error) {
    identifying.value = false
  }
}

onMounted(() => {
  gaAnalytics('p_address_edit_page_view', 'p_address_edit_page_view')
  buriedPointUtil({ eventId: 'PAE501', others: { addressType: props.addressType } })
})

</script>

<style lang="less">
@import './index.less';
</style>
